import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { DisplayInputComponent } from '@components';
import { Store } from '@ngrx/store';
import { UtilService } from '@services';
import {
  fetchCurrentTrip,
  selectCurrentTrip,
  selectTripsFetchedAt,
} from '@state/trip';
import { ServiceRequestsTableComponent } from 'src/app/components/service-requests-table/service-requests-table.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    DisplayInputComponent,
    ServiceRequestsTableComponent,
    MatFormFieldModule,
  ],
  templateUrl: './trip.page.html',
  styleUrl: './trip.page.scss',
})
export class TripPage implements OnInit {
  $trip = this.store.select(selectCurrentTrip);
  $tripsFetchedAt = this.store.select(selectTripsFetchedAt);

  constructor(
    private store: Store,
    private router: Router,
    public utils: UtilService
  ) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchCurrentTrip());
  }

  public navToDriverDetails(userId: string): void {
    this.router.navigate(['/users', userId]);
  }
}
